var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"text-md-center",attrs:{"id":"footer"}},[_vm._v(" "+_vm._s("v" + _vm.version)+" ©2024  "),_c('a',{attrs:{"href":"http://extra.ooo","target":"_blank"}},[_vm._v(_vm._s(_vm.$t("ooo_extra")))]),_vm._v("   +7(499)110-23-26 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }